import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import Navbar from '../../components/Navbar/Navbar'
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Events from '../../api/events'
import { useParams } from 'react-router-dom'
import EventTabs from './alltab'
import EventSidebar from './sidebar'
import ErrorPage from '../ErrorPage/ErrorPage';
import Footer from '../../components/footer/Footer';
import { Image } from '@imagekit/react';



const EventSinglePage = (props) => {

    const { slug } = useParams()
    const { t } = useTranslation('events')

    const eventDetails = Events.find(item => item.slug === slug)

    if (!eventDetails) return <ErrorPage />

    return (
        <Fragment>
            <Navbar />
            <PageTitle pageTitle={t(`items.${slug}.title`)} pagesub={t('pageTitle')} />
            <div className="wpo-event-details-area section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col col-lg-8">
                            <div className="wpo-event-item">
                                <div className="wpo-event-img">
                                    <Image src={eventDetails.eImg} alt="" transformation={[
                                        {
                                            width: "700",
                                            height: "560",
                                            crop: "maintain_ratio",
                                            focus: "auto",
                                        },
                                    ]} />
                                </div>
                                <div className="wpo-event-details-text">
                                    <h2>{t(`items.${slug}.title`)}</h2>
                                    <span className="date">{t(`events:items.${slug}.date`)} @ {eventDetails.time}</span>
                                    {/**<p>{t('single.intro')}</p>*/}
                                </div>
                                <EventTabs eventDetails={eventDetails} />
                            </div>
                        </div>
                        <EventSidebar />
                    </div>
                </div>
            </div>
            <Footer ftClass={'s2'} />
            <Scrollbar />
        </Fragment>
    )
};
export default EventSinglePage;
